import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { Task as TaskType, TaskListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const TASK_FIELDS = `contactId createdById createdDate description dueDate id locationId ownerId roleId completedByUserId status title updatedDate version`

export const TASKS_QUERY = graphql(`
  query Tasks($search: String, $pagination: PaginationInput, $sort: SortInput) {
    tasks(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        contactId
        createdById
        createdDate
        description
        dueDate
        id
        locationId
        ownerId
        roleId
        completedByUserId
        status
        title
        updatedDate
        version
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query TaskStore($id: ID!) {
    task(id: $id) {
      contactId
      createdById
      createdDate
      description
      dueDate
      id
      locationId
      ownerId
      roleId
      completedByUserId
      status
      title
      updatedDate
      version
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateTaskStore($input: CreateTaskInput!) {
    createTask(input: $input) {
      contactId
      createdById
      createdDate
      description
      dueDate
      id
      locationId
      ownerId
      roleId
      completedByUserId
      status
      title
      updatedDate
      version
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateTaskStore($id: ID!, $input: UpdateTaskInput!) {
    updateTask(id: $id, input: $input) {
      contactId
      createdById
      createdDate
      description
      dueDate
      id
      locationId
      ownerId
      roleId
      completedByUserId
      status
      title
      updatedDate
      version
    }
  }
`)

export class TaskStore extends EntityStore<TaskType, TaskListResult, typeof CREATE_MUTATION, typeof UPDATE_MUTATION> {
  constructor(client: Client) {
    super(client, {
      listQuery: TASKS_QUERY,
      getQuery: GET_QUERY,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      extractList: (data: any) => data.tasks,
      extractOne: (data: any) => data.task,
      extractMutated: (data: any) => data.updateTask ?? data.createTask,
    })
  }
}
